import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, CheckCircle2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { DjayToetsAvatar } from '../../mascot';
import type { AssessmentDomainId } from '../types';
interface AssessmentCompleteScreenProps {
  questionCount: number;
  elapsedMs: number;
  domainId?: AssessmentDomainId;
  onViewReport: () => void;
}
export function AssessmentCompleteScreen({
  questionCount,
  elapsedMs,
  domainId = 'rekenen',
  onViewReport
}: AssessmentCompleteScreenProps) {
  const minutes = Math.floor(elapsedMs / 60000);
  const seconds = Math.floor(elapsedMs % 60000 / 1000);
  // Format as readable duration for 9-12 year olds — "12 min 34 sec",
  // never "12:34 minuten" which reads ambiguously (R3 quick fix).
  const timeString = minutes > 0 ? `${minutes} min ${seconds.toString().padStart(2, '0')} sec` : `${seconds} seconden`;
  return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-slate-800" data-id="element-620" data-mp="hu4fgsljo1nc">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="w-full max-w-md text-center" data-id="element-621" data-mp="1w58f3j9sv2vi">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.3,
        type: 'spring',
        bounce: 0.5
      }} className="flex justify-center mb-8" data-id="element-622" data-mp="1hcwrkia5qesy">
          <DjayToetsAvatar domain={domainId} size="lg" animate data-id="element-623" data-mp="256ewduk9whpt" />
        </motion.div>

        <h1 className="text-3xl font-black mb-8 tracking-tight text-slate-900" data-id="element-624" data-mp="2058ylibra49f">
          Je hebt de toets afgerond!
        </h1>

        <div className="bg-white rounded-3xl p-6 mb-10 border border-slate-200 shadow-sm inline-block text-left min-w-[240px]" data-id="element-625" data-mp="oqlq75eq89v3">
          <div className="flex items-center gap-4 mb-4" data-id="element-626" data-mp="3cxc61j7a1uam">
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0" data-id="element-627" data-mp="3cug47jsb6lgw">
              <CheckCircle2 className="w-5 h-5 text-slate-400" data-id="element-628" data-mp="32y3cusk8kjpb" />
            </div>
            <div data-id="element-629" data-mp="330h7x1ex1vwv">
              <p className="text-slate-500 text-sm font-medium" data-id="element-630" data-mp="37wxv9teak68w">Beantwoord</p>
              <p className="text-xl font-bold text-slate-900" data-id="element-631" data-mp="37z0wl9kw9lsx">
                {questionCount}/{questionCount} vragen
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-632" data-mp="2y0l3j12b42gs">
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center shrink-0" data-id="element-633" data-mp="2k7viayulr1kq">
              <Clock className="w-5 h-5 text-slate-400" data-id="element-634" data-mp="2p66s59kwdc2y" />
            </div>
            <div data-id="element-635" data-mp="2a9fp8qc0li8l">
              <p className="text-slate-500 text-sm font-medium" data-id="element-636" data-mp="2a8xk147djtoj">Tijd</p>
              <p className="text-xl font-bold text-slate-900" data-id="element-637" data-mp="2abs5mz24jkjj">{timeString}</p>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} data-id="element-638" data-mp="1vmh39avxfg19">
          <Button onClick={onViewReport} size="xl" className="w-full bg-orange-500 text-white hover:bg-orange-600 shadow-xl rounded-2xl text-fluid-lg font-bold" data-id="element-639" data-mp="25mhl0se5do3c">
            <span className="mr-2" data-id="element-640" data-mp="2ejs0kpxzzze2">Bekijk je Rapport</span>
            <ArrowRight className="w-5 h-5" strokeWidth={3} data-id="element-641" data-mp="2aksw16g6i4n5" />
          </Button>
        </motion.div>
      </motion.div>
    </div>;
}